import styled from "styled-components";

export const AreaTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  img {
    width: 10%;
  }
`;

export const BottomMessage = styled.p`
  text-align: center;
  color: #707070;
`;

export const BottomMessageAccess = styled.p`
  text-align: center;
  color: #707070;
`;

export const ButtonDivision = styled.div`
  width: 70%;
  margin: 2rem auto 1rem auto;

  @media(max-width: 600px) {
    width: 100%;
  }
`;

export const ContainerBody = styled.div`
  padding: 0rem 6rem;

  @media(max-width: 770px) {
    padding: 0rem;
  }
`;

export const HeaderMessage = styled.p`
  font-weight: bold;
  text-align: center;
  color: #707070;
  margin-top: 1rem;
`;

